import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campJmReorder: FaireAdCampaignEntity = {
  token: "camp_jm_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_janmichaels",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 8800,
  startedRunningAt: "2025-02-13",
  segmentMetrics: {
    numReorderConversions: 101,
    salesDollars: 52407,
    totalAdsSpendDollars: 4371,
    returnOnAdSpend: 11.99,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
